import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  AdminLayout,
  AdminToolId,
  adminToolPath,
  DEFAULT_ADMIN_TOOL_ID,
  getAdminToolIdFromSlug,
} from '../../components/AdminLayout';
import { UsersTool } from './tools/UsersTool';

export function AdminPage() {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const slug = location.pathname.replace(/^\/admin\/?/, '');
  const activeTool = slug ? getAdminToolIdFromSlug(slug) : DEFAULT_ADMIN_TOOL_ID;

  useEffect(() => {
    if (!slug) {
      navigate(adminToolPath(DEFAULT_ADMIN_TOOL_ID), { replace: true });
      return;
    }
    if (!activeTool) {
      navigate(adminToolPath(DEFAULT_ADMIN_TOOL_ID), { replace: true });
    }
  }, [activeTool, navigate, slug]);

  if (!isAdmin) {
    return <Navigate to="/app" replace />;
  }

  const toolId: AdminToolId = activeTool ?? DEFAULT_ADMIN_TOOL_ID;

  return (
    <AdminLayout
      activeId={toolId}
      onSelectTool={(id) => navigate(adminToolPath(id))}
      backLabel="Back to app"
      onBack={() => navigate('/app')}
    >
      {({ mobileNavTrigger }) => <UsersTool mobileNavTrigger={mobileNavTrigger} />}
    </AdminLayout>
  );
}
